import React, { useEffect, useRef, useState } from 'react';

import Box from '@mui/material/Box';

import { CanvasSketch } from '../../../../components/CanvasSketch';
import { CanvasImage } from '../../../../components/CanvasImage';
import ImageEditorToolbar from './ImageEditorToolbar';
import { useSessionContext } from '../../../../contexts/SessionContext';
import { useEditorStyles } from '../styles';

export const CanvasView = () => {
  const styles = useEditorStyles();
  const { selectedImage, setSelectedImage, isImageLoading } =
    useSessionContext();

  return (
    <Box>
      <ImageEditorToolbar setSelectedImage={setSelectedImage} />
      <Box
        id="image-editor-canvas"
        sx={{
          ...(styles.editorCanvasWrapper as React.CSSProperties),
          display: isImageLoading ? 'none' : 'flex',
          height: '92vh',
          zIndex: '-1',
        }}>
        <CanvasImage />
        <CanvasSketch />
        <Box sx={styles.imageDimensions}>
          {Math.round(selectedImage?.width || 0)} ×{' '}
          {Math.round(selectedImage?.height || 0)}
        </Box>
      </Box>
    </Box>
  );
};

export default CanvasView;
